// extracted by mini-css-extract-plugin
module.exports = {"container":"TrailStats_container__p4zds","lg":"TrailStats_lg__dUT_j"};